export const joinClasses = (...classes: Array<string | false | undefined>) => {
  return classes
    .filter((v) => !!v)
    .join(' ')
    .trim();
};
